(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyber-packs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cyber-packs')) {
    class CyberPacks extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
      }

      onChange = (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
        const form = input.closest('form');
        if (!form) return;

        const price = form.querySelector('[data-ref="price"]');
        const compare = form.querySelector('[data-ref="compare"]');
        const ahorro = form.querySelector('[data-ref="ahorro"]');
        if (price) price.textContent = input.dataset.price || '';
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }
        if (ahorro) {
          ahorro.textContent = input.dataset.ahorro || '';
          const saving = ahorro.closest('.cyber-pack__saving');
          if (saving) saving.hidden = !input.dataset.ahorro;
        }
      };

      onSubmit = async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.classList.contains('cyber-pack__form')) return;
        if (form.dataset.trasAgregar === 'carro') return; // envío normal: va a /cart

        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        const formData = new FormData(form);
        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));

        try {
          const addUrl = window.Theme?.routes?.cart_add_url || form.getAttribute('action') || '/cart/add';
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData,
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');

          const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => undefined);
          const variantId = String(formData.get('id'));
          const cartEvent = new Event('cart:update', { bubbles: true });
          cartEvent.detail = {
            resource: cart,
            sourceId: variantId,
            data: {
              source: 'cyber-packs',
              itemCount: 1,
              variantId,
              productId: form.closest('.cyber-pack')?.dataset.productId,
              sections: data.sections,
            },
          };
          document.dispatchEvent(cartEvent);

          if (button) {
            const text = button.querySelector('.cyber-pack__btn-text');
            const added = button.querySelector('.cyber-pack__btn-added');
            if (text && added) {
              text.hidden = true;
              added.hidden = false;
              setTimeout(() => {
                text.hidden = false;
                added.hidden = true;
              }, 2200);
            }
          }

          // La ventana "custom-cart-popup" de la tienda ya se abre sola con el
          // evento cart:update. Sin esa ventana se abre el carro lateral, y si el
          // tema tampoco tiene carro lateral, se va a la página del carro.
          const drawer = document.querySelector('cart-drawer-component');
          if (!document.querySelector('.custom-cart-popup')) {
            if (!drawer) {
              window.location.href = window.Theme?.routes?.cart_url || '/cart';
            } else if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
              drawer.open();
            }
          }
        } catch (error) {
          console.error('[cyber-packs]', error);
          form.submit();
        } finally {
          if (button) button.disabled = false;
        }
      };
    }

    customElements.define('cyber-packs', CyberPacks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
